<template>
  <div class="typeNav">
    <div class="typeNav_box">
      <ul>
        <li
          class="typeNav_item"
          v-for="(item, index) in systemNameList"
          :key="index"
          @click="goSystem(item,index)"
        >
          <a href="javascript:;" :class="{selectColor : currentIndex==index}">{{ item.typeNav }}</a>
        </li>
      </ul>
    </div>
    <!-- 抽屉 -->
    <!-- title="证书查询" -->
    <el-drawer
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
      style="text-align: center"
    >
      <div class="drawerBox">
        <h3>证书查询</h3>
        <div class="demo-drawer__content">
          <el-form
            :model="cerQueryForm"
            :rules="cerQueryFormRules"
            ref="cerQueryFormRef"
            label-width="100px"
          >
            <el-form-item label="姓名" prop="xs_xm">
              <el-input
                v-model="cerQueryForm.xs_xm"
                maxlength="6"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证" prop="xs_sfz">
              <el-input
                v-model="cerQueryForm.xs_sfz"
                maxlength="18"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="demo-drawer__footer">
            <el-button type="primary" @click="submitForm()">确 定</el-button>
            <el-button @click="resetForm()">取 消</el-button>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import qs from 'qs';
export default {
  name: "typeNav",
  data() {
    var checkSfz = (rule, value, callback) => {
      let sfz_reg =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!sfz_reg.test(value)) {
        callback(new Error("请输入正确的18位身份证号"));
      } else {
        callback();
      }
    };
    return {
      systemNameList: [
        { id: 0, typeNav: "首页" },
        { id: 1, typeNav: "部门概况" },
        { id: 2, typeNav: "培训动态" },
        { id: 3, typeNav: "培训项目" },
        { id: 4, typeNav: "教学师资" },
        { id: 5, typeNav: "特色课程" },
        { id: 6, typeNav: "高端培训" },
        { id: 7, typeNav: "培训案例" },
        { id: 8, typeNav: "在线学习" },
        { id: 9, typeNav: "证书查询" },
        { id: 10, typeNav: "评价反馈" },
        { id: 11, typeNav: "联系我们" },
      ],
      currentIndex:-1,
      //控制抽屉的是否显示
      drawer: false,
      //控制抽屉显示方式(从上向下)
      direction: "ttb",
      //证书查询表单对象
      cerQueryForm: {
        xs_xm: "",
        xs_sfz: "",
      },
      // 证书查询表单验证规则
      cerQueryFormRules: {
        xs_xm: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        xs_sfz: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: checkSfz, trigger: "blur" },
        ],
      },
    };
  },
  created() {},
  methods: {
    goSystem(item,index) {
      this.currentIndex=index;
      if(item.id == 0){
        //首页
        window.open("http://cce.scu.edu.cn/");
      }else if (item.id == 1) {
        //部门概况
        this.$router.push({path:'/department'});
      } else if (item.id == 2) {
        //培训动态
        window.open("http://cce.scu.edu.cn/mana/view/home/newsList.do?type=30");
      } else if (item.id == 3) {
        //培训项目
        window.open(
          "http://cce.scu.edu.cn/mana/view/home/newsList.do?type=541"
        );
      } else if (item.id == 4) {
        //教学师资
        window.open(
          "http://cce.scu.edu.cn/mana/view/home/newsList.do?type=556"
        );
      } else if (item.id == 5) {
        //特色课程
        window.open(
          "http://cce.scu.edu.cn/mana/view/home/newsList.do?type=541"
        );
      } else if (item.id == 6) {
        //高端培训
        this.$router.push({
          name:"imgDetail"
        })
        // window.open(
        //   "http://cce.scu.edu.cn/mana/view/home/newsList.do?type=555"
        // );
      } else if (item.id == 7) {
        //培训案例
        this.$router.push({path:'/case'});
      } else if (item.id == 8) {
        //在线学习
        window.open(
          "http://cce.scu.edu.cn/mana/pxzxxx.jsp"
        );
      } else if (item.id == 9) {
        //证书查询
        // this.drawer = true;
        this.$router.push({path:'/searchCer'});
      } else if (item.id == 10) {
        //评价反馈
        alert("联系电话：028-85501508");
      } else {
        //联系我们
        this.$router.push({path:'/contactUs'});
      }
    },
    //查询操作
    submitForm() {
      this.$refs.cerQueryFormRef.validate((valid) => {
        if (!valid) return;
          let data = {
            xs_xm: this.cerQueryForm.xs_xm,
            xs_sfz: this.cerQueryForm.xs_sfz,
            timestamp: new Date().getTime(),
            nonceStr: this.randomString()
          }
          data = qs.stringify(data)
          this.$http({
            url: "http://202.115.44.70/eduTrainProj/proj/queryCert",
            method: "post",
            responseType: "json", // 默认的
            data: data
        }).then(function (response) {
            console.log(111, response);
          })
      });
    },
    // 重置表单
    resetForm() {
      this.$refs.cerQueryFormRef.resetFields();
    },
    //关闭抽屉
    handleClose() {
      this.$refs.cerQueryFormRef.resetFields();
      this.drawer = false;
    },
    //生成随机字符串
    randomString() {
      var len = 32;
      var $chars =
        "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length;
      var pwd = "";
      for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
  },
};
</script> 

<style scoped lang="scss">
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.typeNav {
  width: 100%;
  height: 50px;
  .typeNav_box {
    width: 1200px;
    height: 50px;
    margin: 0 auto;
    line-height: 50px;
    .typeNav_item {
      display: inline-block;
      padding-right: 24px;
      &:last-child {
        padding-right: 0;
      }
      a {
        font-size: 16px;
        color: #333;
        text-decoration: none;
        &::before {
          content: "";
          width: 4px;
          height: 4px;
          display: inline-block;
          margin-right: 6px;
          margin-bottom: 4px;
          // border-radius: 2px;
          background-color: #ccc;
        }
        &:hover {
          color: #ba2a17;
        }
        &.selectColor{
          color: #ba2a17;
        }
      }
    }
  }
  ::v-deep .el-drawer {
    text-align: center;
    font-size: 18px !important;
    .el-drawer__header {
      // color: #000 !important;
      margin-bottom: 0 !important;
    }
  }
  .drawerBox {
    width: 1200px;
    height: 200px;
    // background-color: pink;
    margin: 0 auto;
    h3 {
      margin-top: 0;
    }
    .demo-drawer__content {
      .el-form {
        width: 500px;
        margin-left: 26%;
      }
    }
  }
}
::v-deep .el-drawer ttb {
  height: 80% !important;
}

// .dialog-mask {
//   position: fixed;
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(0, 0, 0, 0.5);
// }
</style>
